var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_174_1",
    "data-name": "Component 174 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1142",
    "data-name": "Rectangle 1142",
    width: 41,
    height: 46,
    rx: 6,
    fill: "#382154"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M9125.551,1655.827l-8.971,8.97,8.971,8.97",
    transform: "translate(-9100.566 -1642.021)",
    fill: "none",
    stroke: "#bb84ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleIcon);
export default __webpack_public_path__ + "static/media/title-icon.f77072c68e038e9314bffab84f788602.svg";
export { ForwardRef as ReactComponent };